import { useState, useEffect, useRef } from 'react';
import Search from '@Services/Search';
import QueryParser from '@Services/QueryParser';

export default function useFetchOperatorData() {
  const [operators, setOperatorList] = useState([]);
  const isMounted = useRef(true);

  useEffect(() => {
    const NOT_ALLOWED_OPERATORS = ['COMBINE']; // COMBINE operator is not allowed to use with all querylets, only some forms
    const fetchData = async () => {
      try {
        const data = await Search.getExistingLogicOperators();
        setOperatorList([]);
        const operatorsList = data.filter(({ operator }) => NOT_ALLOWED_OPERATORS.indexOf(operator) === -1);
        const transformedData = operatorsList.map((operatorVal) => {
          return {
            label: operatorVal.operator,
            id: operatorVal.operator,
            supportsQualifier: operatorVal.supportsQualifier ? operatorVal.supportsQualifier : false,
            defaultQualifier: operatorVal.supportsQualifier ? operatorVal.defaultQualifier : 0,
            lowerQualifierBound: operatorVal.supportsQualifier ? operatorVal.lowerQualifierBound : 0,
            upperQualifierBound: operatorVal.supportsQualifier ? operatorVal.upperQualifierBound : 0,
          };
        });
        setOperatorList(transformedData);
        QueryParser.setLogicOperatorsMap(operators);
      } catch (error) {
        Logger.error(error);
      }
    };

    fetchData();
    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { operators };
}
